import { boolean, index, pgTable, text } from 'drizzle-orm/pg-core'
import { getId, getTimestampWithTimezone } from '../common/utils'

export const rateLimitActions = pgTable(
  'rate_limit_actions',
  {
    id: getId(),
    createdAt: getTimestampWithTimezone().notNull().defaultNow(),
    deletedAt: getTimestampWithTimezone(),
    identifier: text().notNull(), // email, phone, or IP address
    action: text().notNull(), // 'request_otp' | 'verify_otp'
    blocked: boolean().notNull().default(false), // Was this attempt blocked?
    blockedUntil: getTimestampWithTimezone(),
    permanentlyBlocked: boolean().notNull().default(false), // Permanent block flag
  },
  (table) => [
    index('rate_limit_actions_created_at_idx').on(table.createdAt),
    index('rate_limit_actions_deleted_at_idx').on(table.deletedAt),
    index('rate_limit_actions_identifier_action_idx').on(
      table.identifier,
      table.action,
    ),
  ],
)
